import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TrendingDebates from "./TrendingDebates";
import { createSlug } from "../helpers/SlugHelper";

interface CommunityTopSectionProps {
  topRanks: any[];
  categoryId: string;
}

const CommunityTopSection = ({
  topRanks,
  categoryId,
}: CommunityTopSectionProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  console.log("CommunityTopSection topRanks", topRanks);

  return (
    <div className="py-16 px-4 ">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Community Top 10 Rappers Column */}
          <div className="card-wrap">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-6">
              🏆 {t("communityTop")}
            </h2>

            {topRanks && topRanks.length > 0 ? (
              <div className="space-y-2">
                {topRanks.slice(0, 10).map((rank: any, index: number) => {
                  const rapperName =
                    rank.Item?.category_label ||
                    rank.category_label ||
                    "Unknown Artist";
                  const rapperSlug = createSlug(rapperName);

                  return (
                    <div
                      key={rank.Item?.id || index}
                      className="flex items-center justify-between card-container"
                    >
                      <div className="flex items-center space-x-3">
                        <span className="text-lg font-bold text-yellow-500 w-8">
                          #{index + 1}
                        </span>
                        <a
                          href={`/rapper/${rapperSlug}`}
                          className="text-white font-medium hover:text-blue-400 transition-colors"
                        >
                          {rapperName}
                        </a>
                      </div>
                      <div className="text-sm text-gray-400">
                        {rank.Item?.number_of_lists ||
                          rank.number_of_lists ||
                          0}{" "}
                        lists
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-gray-400 text-center py-8">
                <p>Loading community rankings...</p>
              </div>
            )}

            <button
              onClick={() => navigate(`/ranks/${categoryId}`)}
              className="w-full mt-6 text-gray-400 hover:text-gray-300 transition-colors"
            >
              {t("buttons.view_full_ranking")} &rarr;
            </button>
          </div>

          {/* Trending Debates Column */}
          <TrendingDebates />
        </div>
      </div>
    </div>
  );
};

export default CommunityTopSection;
